module.exports = __webpack_public_path__ + "static/img/not-data.80c92ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/not-data.png
// module id = HsZ0
// module chunks = 6